const normalizeBaseUrl = (url = '') => url.replace(/\/+$/, '');

const DEFAULT_API_BASE_URL = 'https://testbackend.bulutmarket.com.tr';
const envApiBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim() || '';

export const BASE_URL = normalizeBaseUrl(
  envApiBaseUrl || DEFAULT_API_BASE_URL
);

export const GET_BANK_ACCOUNTS = '/api/public/bank_accounts';
export const GET_ORDER_WARRANTY = '/api/public/warranty/';
export const GET_AUTHSERVICE_BRANDS = '/api/public/authservice_brands/';
export const GET_AUTHSERVICE_BY_BRAND = '/api/public/authservice/';
export const POST_MERCHANT_APPEAL = '/api/public/merchant_appeal';
export const POST_CONTACT = '/api/public/contact';

export const buildPublicApiUrl = (path) => `${BASE_URL}${path}`;
